import { useQuery } from '@tanstack/react-query';

export const queryKey = 'electron-task-create-data';

export const useElectronTaskCreateDataQuery = () =>
  useQuery({
    queryKey: [queryKey],
    queryFn: () => window.electron?.popover.getTaskCreationData(),
  });
